export const sliceNames = Object.freeze({
    LOGIN: "login",
    GLOBAL: "global",
});

export const UNLOADING_PALLETIZE_PALLET_MIN_WEIGHT = 840;
export const UNLOADING_PALLETIZE_PALLET_MAX_WEIGHT = 960;
export const WASHING_PALLETIZE_PALLET_MIN_WEIGHT = 900;
export const WASHING_PALLETIZE_PALLET_MAX_WEIGHT = 1350;
export const SORTING_PALLET_MAX_WEIGHT = 1300;
export const PALLET_GREEN_CASES = 30;
export const PALLET_ORANGE_CASES = 36;
export const GREEN_CASE_WEIGHT = 2.13;

// Previous Value :::::::::::
// export const EMPTY_PALLET_WEIGHT = 15;
// export const PLASTIC_EMPTY_PALLET_WEIGHT = 26;

export const EMPTY_PALLET_WEIGHT = 27;
export const PLASTIC_EMPTY_PALLET_WEIGHT = 27;

export const EMPTY_GREEN_CASE_WEIGHT = 2.13;
export const GREEN_CASE_FRUIT_WEIGHT = 28;
export const EMPTY_ORANGE_CASE_WEIGHT = 2.13;
export const ORANGE_CASE_FRUIT_WEIGHT = 25;
export const EXPECTED_RIPENING_DAYS = 3;
export const MAX_EVAPORATION_PRCNT_ALLOWED = 15;
export const POUND_TO_KG =  0.453592;
export const PASTING_BOX_WEIGHT_IN_POUND =  20;
export const REF_ALLOWED_10LB_BOXES = 165;
export const REF_ALLOWED_20LB_BOXES = 80;
export const DEFAULT_TIMEZONE = "America/Mazatlan";
export const DEFAULT_DATE_FORMAT = "DD-MM-YYYY";
export const DEFAULT_TIME_FORMAT = "hh:mm A";
export const DEFAULT_DATETIME_FORMAT = "DD-MM-YYYY hh:mm A";
export const PROJECT_DATETIME_FORMAT = "DD-MM-YYYY hh:mm A";
export const PROJECT_DATE_FORMAT = "DD-MM-YYYY";
export const COOKING_EST_MINUTE_CHEEKS = 690;
export const COOKING_EST_MINUTE_STRIPS = 570;
export const REJECTED_KG_PER_CASE = 28;
export const MAX_TOTAL_PROCESSING_TRAY = 24;
export const MARGIN_FOR_REJECTED_KG = 0.01;
export const TOTAL_RIPENING_ROOM_CAPACITY = 540;
export const RIPENING_ROOM_CHART_TICK_INTERVAL = 100;